import { render, staticRenderFns } from "./InfoLike.vue?vue&type=template&id=12869fc5&scoped=true&"
import script from "./InfoLike.vue?vue&type=script&lang=js&"
export * from "./InfoLike.vue?vue&type=script&lang=js&"
import style0 from "./InfoLike.vue?vue&type=style&index=0&id=12869fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12869fc5",
  null
  
)

export default component.exports